import React from 'react';

import { Provider } from 'react-redux';
import { BrowserRouter,Routes, Route, useLocation } from 'react-router-dom';
import {store} from './redux/store';
import ReactDOM from 'react-dom/client';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import './style/index.css';
import App from "./App";
import SignIn from './page/SignIn';
import SignUp from './page/SignUp';
import Dashboard from './page/Dashboard';
import Sheet from './page/sheet/Sheet';
import Blog from './page/blog/Blog';
import Desktop from "./page/desktop";
import { SnackbarProvider } from 'notistack';
import Notification from './component/Notification';
import { Renew } from './page/desktop/Renew';
import { AlipayReturnPage } from './page/AlipayReturnPage';
import { WebSites } from './page/desktop/website';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";




const theme = createTheme();
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <SnackbarProvider preventDuplicate maxSnack={5}>
        <Notification/>
        <BrowserRouter>
          <Routes>
            <Route path='/'                         element={<Blog/>} />
            <Route path='/signin'                   element={<SignIn/>} />
            <Route path='/signup'                   element={<SignUp/>} />
            <Route path="/sheet/:id"                element={<Sheet/>} />
            <Route path='/alipay/returnURL'         element={<App><AlipayReturnPage/></App>} />
            <Route path="/console"                  element={<App><Desktop/></App>} />
            <Route path="/console/dashboard"        element={<App><Dashboard/></App>} />
            <Route path="/console/desktop"          element={<App><Desktop/></App>} />
            <Route path="/console/desktop/website"  element={<App><WebSites/></App>} />
            <Route path="/console/desktop/renew"    element={<App><Renew/></App>} />
          </Routes>
        </BrowserRouter>
      </SnackbarProvider>
    </ThemeProvider>
	</Provider>
);
